import React, { useCallback } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { Article } from '../../../../types/items';
import { VolumeUpIcon } from '../../../icon/solid';
import useStyles from './styles';
import {
  setMediaList,
  setOpenMediaViewer,
} from '../../../../store/modules/media-viewer/actions';

type Props = {
  media: Article;
};

const MediaAudio = ({ media }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const title = media.ref?.document?.title || 'Audio';

  const openPreview = useCallback(
    () => {
      if (media.document_id !== -1) {
        dispatch(setMediaList([{
          url: '',
          title,
          id: media.document_id,
          typeId: 3,
        }]));
        dispatch(setOpenMediaViewer(true));
      }
    },
    [dispatch, title, media],
  );

  return (
    <Grid onClick={openPreview} container className={classes.previewWrapper}>
      <Grid
        item
        container
        alignItems="center"
        justify="center"
        className={classes.mediaContainer}
      >
        <Grid item>
          <VolumeUpIcon className={classes.titleIcon} />
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.title}>
        <VolumeUpIcon className={classes.audioIcon} />
        {title}
      </Grid>
    </Grid>
  );
};

export default MediaAudio;
